import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import css from './RelatedArticles.module.scss';
import Button from 'components/Button';
import OnPageEditing from 'components/OnPageEditing';
import { THEMES, getThemeClassNames } from 'constants/themes';
import OnScreen from 'components/OnScreen';
import FluidImage from 'components/FluidImage';
import Published from 'components/Published';
import FeatureArticleTag from "components/FeatureArticleTag";

const RelatedArticles = ({
    blockId,
    heading,
    link,
    linkText,
    onScreen,
    articles,
    theme,
    showMoreArticles,
    showMoreButtonText,
    hasMoreArticles,
    featureArticleListPageLink
}) => (
    <div
        className={cn(css.block, getThemeClassNames(css, theme))}
        data-block={blockId}
    >
        {heading && (
            <OnPageEditing property="Heading">
                <h2 className={cn("block-title-large", css.heading)}>
                    {heading}
                    {featureArticleListPageLink && featureArticleListPageLink.url &&
                        <a
                            className={css.featureArticleListPageLink}
                            href={featureArticleListPageLink.url}
                            target={featureArticleListPageLink.openInNewWindow ? "_blank" : null}
                            rel={featureArticleListPageLink.openInNewWindow ? "noopener noreferrer" : null}
                        >{featureArticleListPageLink.linkText}</a>
                    }
                </h2>
            </OnPageEditing>
        )}
        <OnPageEditing property="Articles">
            <ul className={css.list}>
                {articles && articles.map((article, index) => (
                    <li key={index} className={cn(css.article, {
                        [css["is-on-screen"]]: onScreen
                    })}>
                        <a href={article.link} className={css.articleLink}>
                            <div className={cn("image-wrapper", css.imageWrapper)}>
                                {article.image &&
                                    <FluidImage
                                        altText={article.imageAltText}
                                        className={css.image}
                                        image={article.image}
                                    />
                                }
                                {article.shouldHaveFeatureArticleTag && <FeatureArticleTag />}
                            </div>
                            <div className={css.info}>
                                <h3 className={css.articleHeading}>{article.title}</h3>
                                <div className={css.publishedContainer}>{article.published && <div className={css.articlePublished}><Published isFeatureArticle={article.tag && article.published && true} date={article.published}></Published></div>}
                                    {article.tag && article.published && <span className={css.divider}> - </span>}
                                    {article.tag && <p className={css.articleTag}>{article.tag}</p>}</div>
                            </div>
                        </a>
                    </li>
                ))}
            </ul>
        </OnPageEditing>
        {(link && linkText) ? (
            <OnPageEditing property="LinkToMoreContent">
                <div className={css.button}>
                    <Button secondary href={link} target="_blank" {...{light : theme === THEMES.darkgray}}>
                        {linkText}
                    </Button>
                </div>
            </OnPageEditing>
        ) : (
            (showMoreArticles && showMoreButtonText) && (
                <div className={css.button}>
                    <Button disabled={hasMoreArticles ? false : true} secondary onClick={showMoreArticles} {...{light : theme === THEMES.darkgray}}>
                        {showMoreButtonText}
                    </Button>
                </div>
                
            )
        )}
        
    </div>
);

RelatedArticles.propTypes = {
    blockId: PropTypes.number,
    heading: PropTypes.string,
    link: PropTypes.string,
    linkText: PropTypes.string,
    onScreen: PropTypes.bool,
    articles: PropTypes.array,
    theme: PropTypes.oneOf(
        Object.keys(THEMES).map(s => THEMES[s])
    ),
    showMoreArticles: PropTypes.func,
    showMoreButtonText: PropTypes.string,
    hasMoreArticles:PropTypes.bool,
    shouldHaveFeatureArticleTag: PropTypes.bool,
    featureArticleListPageLink: PropTypes.shape({
        url: PropTypes.string.isRequired,
        linkText: PropTypes.string.isRequired,
        openInNewWindow: PropTypes.bool.isRequired
    })
};

RelatedArticles.defaultProps = {
    theme: THEMES.lightgray
};

export default OnScreen(RelatedArticles);



// WEBPACK FOOTER //
// ./src/components/RelatedArticles/RelatedArticles.jsx